import React from 'react';
import { Modal } from '../ui/Modal.js';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const OrderCancelSuccessModal = ({ isOpen, onClose }) => {
  const { language } = useDataContext();

  return (
    <Modal isOpen={isOpen} onClose={onClose} contentClassName="max-w-[400px]">
      <div className="pt-8 px-6 pb-6">
        <div className="text-center mb-5">
          <div
            className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto mb-5 shadow-[0_4px_16px_rgba(34,197,94,0.3)]"
            style={{ background: 'linear-gradient(135deg, #22c55e, #16a34a)' }}
          >
            <span className="text-3xl">✅</span>
          </div>
          <h3 className="text-xl font-bold text-[#1a1a1a] mb-1.5">
            {translations[language]?.restaurant_menu_cancel_order_successful}
          </h3>
        </div>

        <button
          onClick={onClose}
          className="w-full py-[14px] text-[15px] font-semibold bg-primary hover:bg-secondary text-white border-none rounded-xl cursor-pointer transition-colors duration-200"
        >
          {translations[language]?.close || 'Luk'}
        </button>
      </div>
    </Modal>
  );
};

export default OrderCancelSuccessModal;
